import React, {useEffect, useState} from "react";
import {Grid, Typography, IconButton} from "@mui/material";
import {ArrowBackIos, ArrowForwardIos} from "@mui/icons-material";
import "./BookAppointmentCalender.scss";
import moment from "moment/moment";
import {motion} from "framer-motion";

const CalendarHeader = ({currentMonth, currentYear, onPrevMonth, onNextMonth}: any) => (
    <div className="calendar-header">
        <Typography variant="h6" className="month-year">
            <strong>{new Date(currentYear, currentMonth).toLocaleString("default", {
                month: "long",
                year: "numeric"
            })}</strong>
        </Typography>
        <div className="nav-buttons">
            <IconButton size="small" onClick={onPrevMonth}>
                <ArrowBackIos fontSize="small"/>
            </IconButton>
            <IconButton size="small" onClick={onNextMonth}>
                <ArrowForwardIos fontSize="small"/>
            </IconButton>
        </div>
    </div>
);

const CalendarDays = ({
                          daysOfWeek,
                          daysArray,
                          enabledDates,
                          currentMonth,
                          currentYear,
                          selectedDate,
                          onSelectDate,
                      }: any) => (
    <Grid container className="calendar-grid">
        {daysOfWeek.map((day: any, index: any) => (
            <Grid item key={index} className="day-header">
                {day}
            </Grid>
        ))}
        {daysArray.map((day: any, index: any) => {
            //  const isEnabled = day && enabledDates.includes(`${currentYear}-${currentMonth}-03}`);
            const formattedDate = day ? `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}` : null;
            const isEnabled = day && enabledDates.includes(formattedDate);
            return (
                // <Grid
                //     item
                //     key={index}
                //     className={`day-cell ${day === null ? "empty" : ""} ${
                //         selectedDate && selectedDate.getDate() === day &&
                //         selectedDate.getMonth() === currentMonth &&
                //         selectedDate.getFullYear() === currentYear
                //             ? "selected"
                //             : ""
                //     } ${isEnabled ? "enabled" : "disabled"}`}
                //     onClick={() => isEnabled && onSelectDate(new Date(currentYear, currentMonth, day))}
                // >
                //     {/*<div onClick={() => {*/}
                //     {/*    console.log(day,currentYear,currentMonth);*/}
                //     {/*}}>nikegt*/}
                //     {/*</div>*/}
                //
                //     {day}
                // </Grid>
                <Grid
                    item
                    key={index}
                    className={`day-cell ${day === null ? "empty" : ""}  ${isEnabled ? "enabled" : "disabled"}`}
                    onClick={() => isEnabled && onSelectDate(new Date(currentYear, currentMonth, day))}
                >
                    {/*<div onClick={() => {*/}
                    {/*    console.log(day,currentYear,currentMonth);*/}
                    {/*}}>nikegt*/}
                    {/*</div>*/}
                    <div className={`${
                        selectedDate && selectedDate.getDate() === day &&
                        selectedDate.getMonth() === currentMonth &&
                        selectedDate.getFullYear() === currentYear
                            ? "selected"
                            : ""
                    }`}>
                        {day}
                    </div>
                </Grid>
            );
        })}
    </Grid>
);

const BookAppointmentCalender = ({onDateSelect, enabledDates, calenderSize, defaultDate}: any) => {
    const today = new Date();
    const [currentMonth, setCurrentMonth] = useState(today.getMonth());
    const [currentYear, setCurrentYear] = useState(today.getFullYear());
    const [selectedDate, setSelectedDate] = useState<any>(null);

    const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"];

    // useEffect(() => {
    //     const parsedDate = moment("2025-0202", "YYYY-MM-DD").toDate();
    //     setSelectedDate(parsedDate);
    //     setCurrentMonth(parsedDate.getMonth());
    //     setCurrentYear(parsedDate.getFullYear());
    // }, []);

    useEffect(() => {
        if (!defaultDate) {
            setSelectedDate(null);
        } else {
            const parsedDate = moment(defaultDate, "YYYY-MM-DD").toDate();
            setSelectedDate(parsedDate);
            setCurrentMonth(parsedDate.getMonth());
            setCurrentYear(parsedDate.getFullYear());
        }
    }, [defaultDate]);


    const getDaysInMonth = (month: number, year: number) => Array.from({length: new Date(year, month + 1, 0).getDate()}, (_, i) => i + 1);
    const getFirstDayOfMonth = (month: number, year: number) => new Date(year, month, 1).getDay();

    const handlePrevMonth = () => {
        setCurrentMonth((prev) => (prev === 0 ? 11 : prev - 1));
        if (currentMonth === 0) setCurrentYear((prev) => prev - 1);
        //   setSelectedDate(null);
    };

    const handleNextMonth = () => {
        setCurrentMonth((prev) => (prev === 11 ? 0 : prev + 1));
        if (currentMonth === 11) setCurrentYear((prev) => prev + 1);
        // setSelectedDate(null);
    };

    const handleSelectDate = (date: React.SetStateAction<null>) => {
        setSelectedDate(date);
        console.log(date, moment("2025-03-04")?.toString());
        if (onDateSelect) {
            onDateSelect(date);
        }
    };

    const daysInMonth = getDaysInMonth(currentMonth, currentYear);
    const firstDay = getFirstDayOfMonth(currentMonth, currentYear);
    const daysArray = Array(firstDay).fill(null).concat(daysInMonth);

    const variants = {
        hidden: {opacity: 0, rotate: 0}, // Start: invisible & no rotation
        visible: {
            opacity: 1,
            rotate: 360, // Full 360° rotation
            transition: {duration: 0.8, ease: "easeInOut"}
        }
    };

    const bounceVariants = {
        hidden: {opacity: 0, y: -50}, // Start slightly above
        visible: {
            opacity: 1,
            y: 0,
            transition: {type: "spring", stiffness: 300, damping: 10} // Spring effect
        }
    };
    return (
        <motion.div
            className={`${
                calenderSize === "xl"
                    ? "xl-book-appointment-calendar-container"
                    : "book-appointment-calendar-container"
            }`}
            initial="hidden"
            animate="visible"
            variants={calenderSize === "xl" ? bounceVariants : variants} // Apply animation only if 'xl'
        >
            <CalendarHeader currentMonth={currentMonth} currentYear={currentYear} onPrevMonth={handlePrevMonth}
                            onNextMonth={handleNextMonth}/>
            <CalendarDays daysOfWeek={daysOfWeek} daysArray={daysArray} enabledDates={enabledDates}
                          currentMonth={currentMonth} currentYear={currentYear} selectedDate={selectedDate}
                          onSelectDate={handleSelectDate}/>
        </motion.div>
    );
};

export default BookAppointmentCalender;
